
export enum UnitStatus {
    Responding,
    NoResponseWithin48Hours
}
